import { useDroppable } from '@dnd-kit/core';

export const BranchDropzone = ({ id, children }) => {
  const { setNodeRef } = useDroppable({
    id: id,
  });

  return <div ref={setNodeRef}>{children}</div>;
};
